import { CITIES_OPTIONS } from 'client/constants';

export const getCityById = (cityId: string) => {
  const cityName = CITIES_OPTIONS.find((c) => {
    return c.value === cityId;
  })?.label;

  return cityName ?? cityId;
};
